import { render, staticRenderFns } from "./xxzyrwsy.vue?vue&type=template&id=9b9b2b56&scoped=true&"
import script from "./xxzyrwsy.vue?vue&type=script&lang=js&"
export * from "./xxzyrwsy.vue?vue&type=script&lang=js&"
import style0 from "./xxzyrwsy.vue?vue&type=style&index=0&id=9b9b2b56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9b2b56",
  null
  
)

export default component.exports